import React from 'react';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import mac1 from '../../assets/images/work-5.png';

const Macbook = () => {
    return (
        <div>
            <Navbar />
            <div style={{ marginTop: '100px' }} className='container'>
                <h1 className='main-title text-center'>Macbook Pro <br /> Website</h1>
                <p className='main-info text-center'>Landing Page</p>
                <p className='main-info main-links text-center'><a target='_blank' href="https://github.com/mishrahat/mac-book-pro">Client-Side Code</a> | <a target='_blank' href="https://macbookpro.netlify.app/">Live Site</a></p>
                <img className='w-100 img-fluid img-thumbnail' src={mac1} alt="" />
                <div className='row mt-4'>
                    <div className='col-lg-6 overview'>
                        <h2 style={{ marginLeft: '200px' }}>Project Overview</h2>
                        <p className='work-info' style={{ marginLeft: '200px' }}>Macbook Pro is a basic landing page website project using simple front end technologies.</p>
                    </div>
                    <div className='col-lg-6'>
                        <h2 className='key-points'>Key Points</h2>
                        <ul>
                            <li className='work-info'>Used basic front-end technologies for this particular project.</li>
                            <li className='work-info'><span className='side-site'>Front-End:</span> HTML, CSS, Bootstrap, Javascript, DOM
                            </li>
                            <li className='work-info'>It is a dynamic site where user can add and remove product quantity.</li>
                            <li className='work-info'><span className='side-site'>Tools:</span> Git, Github, Netlify</li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Macbook;